import {
  CButton,
  CButtonGroup,
  CCol,
  CFormInput,
  CRow,
} from "@coreui/react-pro";
import { FC } from "react";
import CIcon from "@coreui/icons-react";
import { cilSearch, cilSync } from "@coreui/icons";

interface AssigneeFilterProps {
  state: {
    searchAssigneeName: string;
  };
  controller: {
    onSearchClicked: () => void;
    onSyncClicked: () => void;
    onAssigneeSearch: (name: string) => void;
  };
}

const AssigneeFilter: FC<AssigneeFilterProps> = ({ state, controller }) => {
  return (
    <>
      <CRow className="justify-content-end me-2">
        <CCol xs="auto">
          <CFormInput
            id="inputForm1"
            placeholder="Name"
            className="filter-input"
            onChange={(e) => controller.onAssigneeSearch(e.target.value)}
            value={state.searchAssigneeName}
          />
        </CCol>
        <CCol xs="auto">
          <CButtonGroup>
            <CButton color="primary" onClick={controller.onSearchClicked}>
              <CIcon icon={cilSearch} title="Search" />
            </CButton>
            <CButton color="#E4E2E2" onClick={controller.onSyncClicked}>
              <CIcon icon={cilSync} title="Reload" />
            </CButton>
          </CButtonGroup>
        </CCol>
      </CRow>
    </>
  );
};

export default AssigneeFilter;
